import { fetchData, ENDPOINT_HOST } from './api_helper';

const apiURL = `${ENDPOINT_HOST}criteria_categories/`;

const fetchCriteriaCategories = (page, searchTerm = '', needAll) => new Promise(((resolve, reject) => {
  let endpointURL = `${apiURL}?page=${page}&term=${searchTerm}`;
  if (needAll) {
    endpointURL = `${apiURL}?need_all=true`;
  }
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchCriteriaCategory = id => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}${id}`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const updateCriteriaCategory = params => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}${params.id}`;
  fetchData(endpointURL, 'put', params, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const createCriteriaCategory = params => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}`;
  fetchData(endpointURL, 'post', params, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const deleteCriteriaCategory = id => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}${id}`;
  fetchData(endpointURL, 'delete', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchCriteriaCategoryTree = (forstatement, language) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}category_tree?for_statement=${forstatement}&language=${language}`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchStatementCriteriaCategory = () => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}statement_category_tree`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchCriteriaCategoryTreeChild = (id, forstatement, siteId) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}${id}/get_category_children?for_statement=${forstatement}&site_id=${siteId}`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const CriteriaCategoryTreeSearch = (searchTerm = '', filterTypes, language) => new Promise(((resolve, reject) => {
  let endpointURL = '';
  if (filterTypes.length === 1) {
    endpointURL = `${apiURL}category_tree_search?filter_types[]=${filterTypes[0]}&term=${searchTerm}&language=${language}`;
  } else if (filterTypes.length === 2) {
    endpointURL = `${apiURL}category_tree_search?filter_types[]=${filterTypes[0]}&filter_types[]=${filterTypes[1]}&term=${searchTerm}&language=${language}`;
  } else if (filterTypes.length === 3) {
    endpointURL = `${apiURL}category_tree_search?filter_types[]=${filterTypes[0]}&filter_types[]=${filterTypes[1]}&filter_types[]=${filterTypes[2]}&term=${searchTerm}&language=${language}`;
  } else {
    endpointURL = `${apiURL}category_tree_search?filter_type=default&term=${searchTerm}`;
  }
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));


const CriteriaCategoryForStatementTreeSearch = (searchTerm = '', siteId) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}category_tree_for_statements_search?term=${searchTerm}&site_id=${siteId}`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));


export default {
  fetchCriteriaCategories,
  fetchCriteriaCategory,
  updateCriteriaCategory,
  createCriteriaCategory,
  deleteCriteriaCategory,
  fetchCriteriaCategoryTree,
  fetchCriteriaCategoryTreeChild,
  CriteriaCategoryTreeSearch,
  CriteriaCategoryForStatementTreeSearch,
  fetchStatementCriteriaCategory,
};



// WEBPACK FOOTER //
// ./src/api/criteria_categories.js